import { Center, Menu, Text } from '@chakra-ui/react';
import { useRepairFocus } from '@halo/ui-react';
import { Tooltip } from '@halo/ui-chat-react';
import { Portal } from '@halo/ui-react';
import { useTranslation } from 'react-i18next';
import { ExpireMessageIconLine } from '../../../../ExpireMessageIcon';
import { tools } from '../../../../../utils';

export type ExpireTimeSelectorProps = {
  value?: number;
  onChange?: (value: number) => void;
};

export const ExpireTimeSelector = function ExpireTimeSelector({
  value,
  onChange,
}: ExpireTimeSelectorProps) {
  const { t } = useTranslation();
  const { handleOpenChange } = useRepairFocus();
  const triggerId = useId();

  return (
    <Menu.Root
      ids={{ trigger: triggerId }}
      positioning={{ placement: 'top' }}
      onSelect={({ value }) => {
        onChange?.(Number(value));
      }}
      onOpenChange={handleOpenChange}
    >
      <Tooltip
        ids={{ trigger: triggerId }}
        content={t('chat.tooltipAutoDeleteMessages')}
        chakraPortal={false}
        openDelay={0}
        closeDelay={0}
        showArrow={true}
      >
        <Menu.Trigger asChild>
          <Center
            h="1.857em"
            w="1.857em"
            cursor="pointer"
            borderRadius="sm"
            _hover={{ bg: 'bg.muted', color: 'brand.100' }}
            transition="all 0.2s"
          >
            <Center className="shake">
              <ExpireMessageIconLine value={value!} />
            </Center>
          </Center>
        </Menu.Trigger>
      </Tooltip>
      <Portal>
        <Menu.Positioner>
          <Menu.Content
            className="blurContent"
            borderRadius="lg"
            minW="186px"
            animationName={{
              _open: 'slide-from-bottom, fade-in',
              _closed: 'slide-to-bottom, fade-out',
            }}
            animationDuration="slower"
            backdropFilter="blur(6px)"
            bg="whiteAlpha.70"
          >
            <Menu.Arrow />
            {tools.expireTimeOptions.map((option, index) => {
              const iValue = String(option.value);
              const isLast = index === tools.expireTimeOptions.length - 1;
              return (
                <Menu.Item
                  key={option.key}
                  value={iValue}
                  gap="0"
                  px="2"
                  py="3"
                  borderRadius="sm"
                  cursor="pointer"
                  _hover={{ bg: 'bg.muted' }}
                  bg={option.value === value ? 'bg.muted' : 'transparent'}
                  borderTop={isLast ? '1px solid' : undefined}
                  borderTopColor={isLast ? 'border.muted' : undefined}
                >
                  {/* <ExpireMessageIconLine value={option.value} /> */}
                  <Text>{option.label}</Text>
                </Menu.Item>
              );
            })}
          </Menu.Content>
        </Menu.Positioner>
      </Portal>
    </Menu.Root>
  );
};
